import React from "react";
import PitchDeckTableRows from "./pitch-deck-table-rows";

const PitchDeckTable = ({ props, rowArray }) => {
  return (
    <table id="view-page" className="idea-checker-table">
      {/* form fields */}
      <tbody>
        <PitchDeckTableRows
          props={props}
          rowArray={rowArray}
        />
      </tbody>
    </table>
  );
};

export default PitchDeckTable;